var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticStyle:{"color":"#ECECEC","font-weight":"500"},attrs:{"items":_vm.bcItems},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('span',{staticStyle:{"color":"rgb(229 234 255)"}},[_vm._v("/")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }